var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoClipboardChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "19px",
    viewBox: "0 0 14 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin-Flows",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-TSP/Admin",
    transform: "translate(-25.000000, -222.000000)",
    fill: "#FF5F00",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico_pins-copy",
    transform: "translate(25.000000, 222.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,2 L3,0 L11,0 L11,2 L14,2 L14,19 L0,19 L0,2 L3,2 Z M5,2 L5,4 L9,4 L9,2 L5,2 Z M2,4 L2,17.0384406 L12,17 L12,4 L11,4 L11,6 L3,6 L3,4 L2,4 Z M5.838,11.051 L9.889,7 L11.303,8.414 L5.838,13.879 L2.65,10.696 L4.064,9.279 L5.838,11.051 Z",
    id: "shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoClipboardChecked);
export default __webpack_public_path__ + "static/media/ico_clipboard_checked.ba170aeef0a390c1140dcb8ce52e4e4b.svg";
export { ForwardRef as ReactComponent };